/* @flow */

import * as React from 'react';
import { Link } from 'react-router-dom';

import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './Tag.style';

type Props = {
  children: React.Node,
  onClick?: ?() => void,
  isInactive?: boolean,
  to: string,
};

const useStyles = createUseThemeStyles(styles);

const TagLink = ({ children, onClick, isInactive, to }: Props): React.Node => {
  const classes = useStyles({
    isInactive,
  });

  if (isInactive) {
    return <span className={classes.root}>{children}</span>;
  }
  return (
    <Link className={classes.root} to={to} onClick={onClick}>
      {children}
    </Link>
  );
};

export default React.memo<Props>(TagLink);
